import {GenericButton} from "../buttons/customButtons";
import { Spinner} from "reactstrap";
import SelectGeneric from "../select/selectGeneric";
import {DragDropList} from "../draggableList/DragDropList";
import React from "react";
import PropTypes from "prop-types";

export const GenericContainer = ({
    titlle,
    listItems,
    renderContent = null,
    orientationHV = 'vertical-container',
    fullheight = true,
    loading = false,

    provider,
    option,
    setOption,
    providerFilter,

    onCreateItem = null,
    onAddItem = null,
    onReorderItems = null,
} = {}) => {

    return (
        <div className={'generic-sortable-container' + (fullheight ? ' full-height' : '')}>
            {
                (titlle || onCreateItem) &&
                <div className={'generic-sortable-container-header'}>
                    {
                        titlle && <h2>{titlle}</h2>
                    }
                    <div className={'top-right-header'}>
                        {
                            onCreateItem &&
                            <GenericButton
                                style={'table'}
                                label={'Nuevo'}
                                toolTip={'Genera un nuevo registro'}
                                icon={'fa-plus'}
                                permission={'add'}
                                onClick={onCreateItem}/>
                        }
                    </div>
                </div>
            }
            <div className={'generic-sortable-container-list'}>
                {
                    provider &&
                    <div className={'generic-sortable-container-options'}>
                        <SelectGeneric
                            initialValue={option}
                            setExternalValue={setOption}
                            provider={provider}
                            customFilter={providerFilter}
                        />
                        <GenericButton
                            style={'table'}
                            toolTip={'Vincular'}
                            label={'Vincular'}
                            icon={'fa-plus'}
                            permission={'add'}
                            onClick={_ => onAddItem(option)} />
                    </div>
                }
                {
                    loading ?
                        <Spinner/> :
                        <div className={orientationHV}>
                            {
                                listItems?.length > 0 ?
                                    onReorderItems !== null ?
                                        <DragDropList
                                            items={listItems?.sort((a, b) => a?.showOrder - b?.showOrder)}
                                            renderContent={renderContent}
                                            onReorder={onReorderItems}
                                            orientationHV={''} // CSS : vertical-container, horizontal-container, ruby-container
                                            className={''}
                                        /> :
                                        listItems?.sort((a, b) => a?.showOrder - b?.showOrder)?.map((item, index) => {
                                            return renderContent(item, index)
                                        }) : null
                            }
                            {
                                listItems?.length <= 0 &&
                                <div className={'generic-sortable-container-empty'}>
                                    <h3>No hay elementos</h3>
                                </div>
                            }
                        </div>
                }
            </div>
        </div>
    );
}

GenericContainer.propTypes = {
    titlle: PropTypes.string,
    listItems: PropTypes.array.isRequired,
    renderContent: PropTypes.func.isRequired,
    loading: PropTypes.bool,


    provider: PropTypes.func,
    option: PropTypes.any,
    providerFilter: PropTypes.object,
    setOption: PropTypes.func
};